// Dashboard.jsx
import React from "react";
import { Box, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./layout/Header";
import Sidebar from "./layout/Sidebar";

// must match Sidebar defaults
const COLLAPSED_WIDTH = 72;
const EXPANDED_WIDTH = 280;

export default function Dashboard() {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [sidebarExpanded, setSidebarExpanded] = React.useState(false);

    const handleDrawerToggle = () => setMobileOpen((p) => !p);
    const handleSidebarToggle = () => setSidebarExpanded((p) => !p);

    const sidebarWidth = sidebarExpanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH;

    return (
        <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
            <Header onOpenNav={handleDrawerToggle} sidebarWidth={sidebarWidth} />

            <Sidebar
                mobileOpen={mobileOpen}
                onClose={handleDrawerToggle}
                expanded={sidebarExpanded}
                onToggleExpanded={handleSidebarToggle}
                collapsedWidth={COLLAPSED_WIDTH}
                expandedWidth={EXPANDED_WIDTH}
            />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,

                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh",
                }}
            >
                {/* Platzhalter für fixe AppBar-Höhe */}
                <Toolbar />

                <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}
